import {
  getAvailablePaymentMethods,
  getPaycheckoutConfiguration,
  getPaycheckoutTheme,
  updatePaycheckoutConfiguration,
  updatePaycheckoutTheme,
} from 'src/clients';
import { RootState } from 'src/redux/reducers/rootReducer';
import {
  PaycheckoutConfigurationParams,
  PaycheckoutSettingsParams,
} from '../types';
import { ACTION_TYPES } from './types';

export const loadAvailablePaymentMethods = () => {
  return {
    types: [
      ACTION_TYPES.LOAD_AVAILABLE_PAYMENT_METHODS,
      ACTION_TYPES.LOAD_AVAILABLE_PAYMENT_METHODS_SUCCESS,
      ACTION_TYPES.LOAD_AVAILABLE_PAYMENT_METHODS_FAILED,
    ],
    client: getAvailablePaymentMethods,
    shouldCallAPI: (state: RootState) =>
      !state.paymentCheckout.paymentMethods.data &&
      !state.paymentCheckout.paymentMethods.isLoading,
  };
};

export const loadPaycheckoutSettings = () => {
  return {
    types: [
      ACTION_TYPES.PAYCHECKOUT_LOAD_SETTINGS,
      ACTION_TYPES.PAYCHECKOUT_LOAD_SETTINGS_SUCCESS,
      ACTION_TYPES.PAYCHECKOUT_LOAD_SETTINGS_FAILED,
    ],
    client: () => getPaycheckoutTheme(),
  };
};

export const updatePaycheckoutSettings = (
  params: PaycheckoutSettingsParams,
) => {
  return {
    types: [
      ACTION_TYPES.PAYCHECKOUT_UPDATE_SETTINGS,
      ACTION_TYPES.PAYCHECKOUT_UPDATE_SETTINGS_SUCCESS,
      ACTION_TYPES.PAYCHECKOUT_UPDATE_SETTINGS_FAILED,
    ],
    client: () => updatePaycheckoutTheme(params),
  };
};

export const loadPaycheckoutConfiguration = () => {
  return {
    types: [
      ACTION_TYPES.PAYCHECKOUT_LOAD_CONFIGURATION,
      ACTION_TYPES.PAYCHECKOUT_LOAD_CONFIGURATION_SUCCESS,
      ACTION_TYPES.PAYCHECKOUT_LOAD_CONFIGURATION_FAILED,
    ],
    client: () => getPaycheckoutConfiguration(),
  };
};

export const savePaycheckoutConfiguration = (
  params: PaycheckoutConfigurationParams,
) => {
  return {
    types: [
      ACTION_TYPES.PAYCHECKOUT_UPDATE_CONFIGURATION,
      ACTION_TYPES.PAYCHECKOUT_UPDATE_CONFIGURATION_SUCCESS,
      ACTION_TYPES.PAYCHECKOUT_UPDATE_CONFIGURATION_FAILED,
    ],
    client: () => updatePaycheckoutConfiguration(params),
  };
};

export const setShowCreatePaymentCheckoutModal = (payload: boolean) => {
  return {
    type: ACTION_TYPES.SET_SHOW_CREATE_PAYMENT_CHECKOUT_MODAL,
    payload,
  };
};

export const setShowCreateReusableModal = (payload: boolean) => {
  return {
    type: ACTION_TYPES.SET_SHOW_CREATE_REUSABLE_MODAL,
    payload,
  };
};
